// Libraries
import { Injectable, Inject } from '@angular/core';
import {
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpEvent,
  HttpResponse,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/do';

// Services
import {
  HandleResponseErrors,
  HANDLE_RESPONSE_ERRORS_SERVICE
} from './handle-response-errors.service';

/**
 * `HandleResponseErrorsInterceptor` intercept backend request and handle http errors.
 *
 * @author Joaquin Volpe <joaquin.volpe@woopasoft.com>
 * @export
 */
@Injectable()
export class HandleResponseErrorsInterceptor implements HttpInterceptor {

  /**
   * Creates an instance of HandleResponseErrorsInterceptor.
   *
   * @author Joaquin Volpe <joaquin.volpe@woopasoft.com>
   * @memberof HandleResponseErrorsInterceptor
   */
  constructor(
    @Inject(HANDLE_RESPONSE_ERRORS_SERVICE) private handleResponseErrorsService: HandleResponseErrors
  ) {
  }

  // Public methods
   /**
    * Intercept http request to add port id and profile id to params.
    *
    * @author Joaquin Volpe <joaquin.volpe@woopasoft.com>
    * @memberof HandleResponseErrorsInterceptor
    */
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Pass on the cloned request instead of the original request.
    return next.handle(req).do (
      (event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          // Do nothing
        }
      }, (err: any) => {
        if (err instanceof HttpErrorResponse) {
          this.handleErrorResponse(err);
        }
      }
    );
  }

  // Private methods
  /**
   * Handle reponse from backend
   *
   * @author Joaquin Volpe <joaquin.volpe@woopasoft.com>
   * @memberof HandleResponseErrorsInterceptor
   */
  private handleErrorResponse(response: HttpErrorResponse) {
    // Check status request
    switch (response.status) {
      case 0:
        this.handleResponseErrorsService.handlesResponse0(response);
        break;
      case 401:
        this.handleResponseErrorsService.handlesResponse401(response);
        break;
      case 403:
        this.handleResponseErrorsService.handlesResponse403(response);
        break;
      case 500:
        this.handleResponseErrorsService.handlesResponse500(response);
        break;
      default:
        this.handleResponseErrorsService.handlesDefaultError(response);
        break;
    }
  }
}
